export default "<div class=\"loading\">\n  <mat-spinner [diameter]=\"70\"></mat-spinner>\n</div>\n"